import moment from "moment";
import Overlay from "ol/Overlay";
import { fromLonLat } from "ol/proj";
import spriteNative from "./assets/nativeIcons/icons.svg";
import sprite from "../../assets/icons.svg";
import { getLocalizedString } from "../../shared/translation";
import { createMapInfoDialog, createSpriteIcon } from "../../components/QIMapInfoDialog";

//Time Status
export const getTimeGap = (sourceTime) => {
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const date = new Date();
  let currentTime = date.getTime();
  let timeGap = currentTime - sourceTime;
  let activityTimeMap = {
    minutes: Math.floor(timeGap / minute),
    hours: timeGap / hour,
    days: Math.round(timeGap / day),
  };
  let status;
  let description;
  let activeWithin;
  let activeWithinTooltip;
  if (sourceTime) {
    status = "active";
    description = "Active";
    activeWithin = activeWithinTooltip = "Now";
    if (activityTimeMap.minutes >= 1 && activityTimeMap.minutes <= 59) {
      if (activityTimeMap.minutes < 5) {
        status = "active";
        description = "Active";
      } else {
        status = "idle";
        description = "Idle";
      }
      if (activityTimeMap.minutes == 1) {
        activeWithin = `${activityTimeMap.minutes} m`;
        activeWithinTooltip = `${activityTimeMap.minutes} min ago`;
      } else {
        activeWithin = `${activityTimeMap.minutes} m`;
        activeWithinTooltip = `${activityTimeMap.minutes} mins ago`;
      }
    } else if (activityTimeMap.minutes >= 60 && activityTimeMap.hours < 24) {
      status = "offline";
      description = "Recently Active";
      let hoursText = "h";
      let hoursTextTooltip = "";
      let minutesText = "m";
      let minutesTextTooltip = "";
      if (Math.floor(activityTimeMap.hours) == 1) {
        hoursTextTooltip = "hr";
      } else {
        hoursTextTooltip = "hrs";
      }

      if (activityTimeMap.minutes % 60 == 1) {
        minutesTextTooltip = "min";
      } else {
        minutesTextTooltip = "mins";
      }
      activeWithin = `${Math.floor(activityTimeMap.hours)} ${hoursText} ${
        activityTimeMap.minutes % 60 == 0 ? "" : `${activityTimeMap.minutes % 60} ${minutesText}`
      }`;
      activeWithinTooltip = `${Math.floor(activityTimeMap.hours)} ${hoursTextTooltip} ${
        activityTimeMap.minutes % 60 == 0
          ? ""
          : `${activityTimeMap.minutes % 60} ${minutesTextTooltip}`
      } ago`;
    } else if (activityTimeMap.days >= 1 && activityTimeMap.days < 2) {
      status = "offline";
      description = "Active within 2 days";
      let hoursText = "h";
      let hoursTextTooltip = "";
      if (Math.floor(activityTimeMap.hours % 24) == 1) {
        hoursTextTooltip = "hr";
      } else {
        hoursTextTooltip = "hrs";
      }
      activeWithin = `${Math.floor(activityTimeMap.days)} d ${
        Math.floor(activityTimeMap.hours % 24) == 0
          ? ""
          : `${Math.floor(activityTimeMap.hours % 24)} ${hoursText}`
      }`;
      activeWithinTooltip = `${Math.floor(activityTimeMap.days)} day ${
        Math.floor(activityTimeMap.hours % 24) == 0
          ? ""
          : `${Math.floor(activityTimeMap.hours % 24)} ${hoursTextTooltip}`
      } ago`;
    } else if (activityTimeMap.days >= 2) {
      status = "offline";
      description = "Inactive";
      activeWithin = `${moment(sourceTime).format("DD/MM/YY")}`;
      activeWithinTooltip = `${moment(sourceTime).format("DD/MM/YY - hh:mm A")}`;
    }
  } else {
    status = "offline";
    description = "Inactive";
    activeWithin = activeWithinTooltip = getLocalizedString("never", "Never");
  }
  return {
    status,
    description,
    activeWithin,
    activeWithinTooltip,
  };
};

//Ignition Status
export const getIgnitionStatus = (ignition_data) => {
  let ignition = ignition_data;
  //Need to check why converted to upper case
  if (typeof ignition === "string") {
    ignition = ignition?.toUpperCase();
  } else {
    ignition = String(ignition).toUpperCase();
  }
  if (ignition === "TRUE" || ignition === "ON" || ignition === true) {
    ignition = "On";
  } else if (ignition === "FALSE" || ignition === "OFF" || ignition === false) {
    ignition = "Off";
  } else {
    ignition = "Not Available";
  }
  return ignition;
};

//Ignition Status
export const ignitionStatus = (ignition) => {
  //Need to check why converted to upper case
  if (typeof ignition === "string") {
    ignition = ignition?.toUpperCase();
  }
  if (ignition === "TRUE" || ignition === "ON" || ignition === true) {
    return (
      <span className="ignition on" title={"On"}>
        <svg className="icon engine on">
          <use href={`${spriteNative}#engine`}></use>
        </svg>
      </span>
    );
  } else if (ignition === "UNKNOWN") {
    return (
      <span className="ignition unknown" title={"This device doesn't support ignition status"}>
        <svg className="icon engine unknown">
          <use href={`${spriteNative}#engine`}></use>
        </svg>
      </span>
    );
  } else {
    return (
      <span className="ignition off" title={"Off"}>
        <svg className="icon engine off">
          <use href={`${spriteNative}#engine`}></use>
        </svg>
      </span>
    );
  }
};

//Remoes duplicate objects in an array (retains first occurence)
export const removeDuplicates = (arr) => {
  const uniqueObject = {};
  const uniqueArray = [];

  arr.forEach((obj) => {
    const strObj = JSON.stringify(obj);
    if (!uniqueObject[strObj]) {
      uniqueObject[strObj] = true;
      uniqueArray.push(obj);
    }
  });

  return uniqueArray;
};

//Calculate Distance with Lat,Lng
export function calculateDistance(gps_distance) {
  // Fix unit into KM only
  return (gps_distance / 1000).toFixed(1) + " km";
}

//events type
export function eventsType(event, sub_type) {
  if (event === "speeding" && sub_type === "geofence") {
    return `${capitalizeAllFirstLetters(event)} (${capitalizeAllFirstLetters(sub_type)})`;
  }
  switch (event) {
    case "over_speed":
      return "Speeding";
    case "New":
      return "Started";
    case "Completed":
      return "Ended";
    case "":
      return "NA";
    case null:
      return "NA";
    case true:
      return "True";
    case false:
      return "False";
    default:
      return capitalizeAllFirstLetters(event ? event : "");
  }
}
/* Trips,Events & Activities */
export function extractKeyValuePairs(obj, parentKey = "") {
  return Object.keys(obj).reduce((acc, key) => {
    const currentKey = parentKey ? `${parentKey}.${key}` : key;
    if (obj[key] && typeof obj[key] === "object") {
      return acc.concat(extractKeyValuePairs(obj[key], currentKey));
    }
    return acc.concat({ [currentKey]: obj[key] });
  }, []);
}

/* Track Points */
export function extractKeyValuePairsTrackPoints(obj, parentKey = "") {
  return Object.keys(obj).reduce((acc, key) => {
    const currentKey = parentKey ? `${key}` : key;
    if (obj[key] && typeof obj[key] === "object") {
      return acc.concat(extractKeyValuePairsTrackPoints(obj[key], currentKey));
    }
    return acc.concat({ [currentKey]: obj[key] });
  }, []);
}

export function capitalizeFirstLetter(string) {
  const updatedString = String(string).split("_").join(" ");
  return updatedString.charAt(0).toUpperCase() + updatedString.slice(1);
}
//Capitalize
export function capitalize(str) {
  return str && str[0].toUpperCase() + str.slice(1);
}

//Replace underscore with space and start each word in upper case
export function capitalizeAllFirstLetters(string) {
  const originalString = String(string).split(/[_\.]/).join(" ");
  const words = originalString.split(" ");
  return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}

export function getDuration(value, type = "ms") {
  let duration;

  switch (type) {
    case "ms":
      duration = value;
      break;
    case "s":
      duration = value * 1000;
      break;
    case "h":
      duration = value * 60 * 60 * 1000;
      break;
    case "min":
      duration = value * 60 * 1000;
      break;
    default:
      break;
  }

  const momentDuration = moment.duration(duration);
  const days = Math.floor(momentDuration.asDays());
  const hours = Math.floor(momentDuration.asHours());
  const minutes = momentDuration.minutes();
  const seconds = momentDuration.seconds();

  const padZero = (num) => (num < 10 ? "0" + num : num);

  let formatted;

  if (hours >= 24) {
    formatted = `${padZero(days)}d ${padZero(hours - days * 24)}:${padZero(minutes)}`;
  } else {
    formatted = `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
  }

  return formatted;
}

export function flattenObject(obj, parentKey = "") {
  let result = {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
        // Recursively flatten nested objects
        const flattened = flattenObject(obj[key], newKey);
        result = { ...result, ...flattened };
      } else {
        result[newKey] = obj[key];
      }
    }
  }

  return result;
}

export function removeDuplicateLabels(arr) {
  const uniqueLabels = {};
  return arr.filter((item) => {
    if (!uniqueLabels[item.label]) {
      uniqueLabels[item.label] = true;
      return true;
    }
    return false;
  });
}
//Remove duplicates in arrey of objects (retains first occurence)
export function uniqueArray(data) {
  return data.reduce((acc, current) => {
    const x = acc.find((item) => item.name === current.name);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);
}

export function keyFormatter(key) {
  switch (key) {
    case "name":
      return "address";
    default:
      return key;
  }
}

export function roundOf(value, variable, defaultPrecision = null) {
  if (typeof value === "number") {
    if (variable?.variable_type === "Number") {
      if (variable.precision != null) {
        return value?.toFixed(variable?.precision);
      } else if (defaultPrecision >= 0) {
        return value?.toFixed(defaultPrecision);
      }
    }
  }
  return value;
}

export function valueFormatter(key, value, variableData) {
  if (value === "NA") {
    return value;
  }
  if (variableData) {
    const variable = variableData[key];
    if (variable?.variable_type === "Timestamp") {
      value = moment(Number(value))?.format(" DD/MM/YY - hh:mm:ss A");
      return capitalizeFirstLetter(String(value));
    } else if (variable?.unit_value === "m/s") {
      return roundOf(Number(value) * 3.6, variable, 1) + " km/h";
    } else if (
      (variable?.variable_type === "Duration" || variable?.variable_type === "Number") &&
      (variable?.unit_value === "s" || variable?.unit_value === "ms")
    ) {
      return getDuration(roundOf(Number(value), variable), variable?.unit_value);
    } else if (variable?.unit_value === "m" && variable?.variable_type === "Number") {
      if (value >= 10000) {
        return roundOf(value / 1000, variable, 0) + " km";
      } else if (value >= 1000 && value < 10000) {
        return roundOf(value / 1000, variable, 1) + " km";
      } else {
        if (value) {
          if (typeof value === "number") {
            if (variable?.variable_type === "Number") {
              value = roundOf(value, variable, 2);
            } else {
              value = value?.toFixed(2);
            }
          }
        }
      }
    } else if (variable?.variable_type === "Number") {
      value = roundOf(value, variable);
    }
  } else {
    return `${capitalizeFirstLetter(String(value))} ${
      (value && value !== "NA") || value == 0 ? displayUnitName(variableData, key) : ""
    }`;
  }

  return `${capitalizeFirstLetter(String(value))} ${
    (value && value !== "NA") || value == 0 ? displayUnitName(variableData, key) : ""
  }`;
}

export const displayKeyName = (variableData, key) => {
  if (variableData) {
    return variableData[key]?.display_name
      ? variableData[key]?.display_name
      : capitalizeAllFirstLetters(key)
      ? capitalizeAllFirstLetters(key)
      : null;
  } else {
    return capitalizeAllFirstLetters(key);
  }
};

export const displayUnitName = (variableData, key) => {
  return variableData && variableData[key]?.unit_value ? variableData[key]?.unit_value : "";
};

export const displayTableConfigName = (variableData, key) => {
  if (variableData && variableData[key]?.display_name) {
    return `${variableData[key]?.display_name} ${
      variableData[key]?.section_name
        ? `(${variableData[key]?.section_name}${
            variableData[key]?.unit_name !== "Not applicable"
              ? "- " + variableData[key]?.unit_name
              : ""
          })`
        : ""
    }`;
  } else {
    return capitalizeAllFirstLetters(key);
  }
};

export function removeArrayValues(obj) {
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      delete obj[key];
    }
  }
  return obj;
}

export function spreadDeviceDataObject(obj) {
  const result = {};

  function spreadHelper(currentObj, parentKey = "") {
    for (const key in currentObj) {
      if (Array.isArray(currentObj[key]?.v)) {
        currentObj[key]?.v?.forEach((item) => {
          spreadHelper(item, parentKey ? `${key}` : key);
        });
      }
      if (key === "t") {
        continue;
      }
      if (typeof currentObj[key] === "object" && !Array.isArray(currentObj[key])) {
        spreadHelper(currentObj[key], parentKey ? `${parentKey}.${key}` : key);
      } else {
        if (key === "v") {
          const newKey = parentKey || key;
          result[newKey.replace(".v.", ".")] = currentObj[key];
        } else {
          const newKey = parentKey ? `${parentKey}.${key}` : key;
          result[newKey.replace(".v.", ".")] = currentObj[key];
        }
      }
    }
  }

  spreadHelper(obj);
  return removeArrayValues(result);
}

export function getValueByNestedKey(obj, key) {
  const keys = key.split(".");
  let value = obj;
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      break;
    }
  }
  return value;
}

export function removeConsecutiveDuplicates(arr) {
  let result = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] !== arr[i + 1]) {
      result.push(arr[i]);
    }
  }
  return result;
}

export function msToKmph(mps) {
  return mps * 3.6;
}

/**
 * Speed threshold (in km/h) used to distinguish a moving vehicle from a
 * paused one. A normalized speed strictly greater than this value is
 * considered "moving".
 * @type {number}
 */
export const SPEED_THRESHOLD_KMPH = 3.0;

// Temporary for the current release: telemetry may report ignition Off while
// a vehicle is moving. Set this back to false in the next release to restore
// the ignition-based movement rules below.
const IGNORE_IGNITION_FOR_MOVEMENT_STATUS = true;

/**
 * Rounds a number to a fixed number of decimal places using
 * "round half away from zero" semantics (e.g. 2.95 -> 3.0, -2.95 -> -3.0),
 * which keeps rounding symmetric for negative inputs.
 * @param {number} value - The value to round.
 * @param {number} decimals - Number of decimal places to round to.
 * @returns {number} The rounded value.
 */
export function roundHalfAwayFromZero(value, decimals) {
  const factor = Math.pow(10, decimals);
  const sign = value < 0 ? -1 : 1;
  return (sign * Math.round(Math.abs(value) * factor)) / factor;
}

/**
 * Normalizes a raw speed in metres per second into a non-negative km/h value
 * rounded to 1 decimal place. Non-finite or negative inputs are clamped to 0.0.
 * Reuses the existing {@link msToKmph} helper for the m/s -> km/h conversion.
 * @param {*} speedMps - Raw speed in metres per second (any type; coerced via Number).
 * @returns {number} Normalized speed in km/h, rounded to 1 decimal, never negative.
 */
export function normalizeSpeedKmph(speedMps) {
  const n = Number(speedMps);
  if (!Number.isFinite(n) || n < 0) return 0.0;
  const kmph = msToKmph(n);
  return roundHalfAwayFromZero(kmph, 1);
}

function parseSourceTimestamp(sourceTime) {
  if (sourceTime === null || sourceTime === undefined || sourceTime === "") return NaN;
  const numericValue = Number(sourceTime);
  return Number.isFinite(numericValue) ? numericValue : Date.parse(sourceTime);
}

/**
 * Generic device_data activity time (`source_time`, falling back to `server_time`).
 *
 * For a speed observation use {@link getVehicleSpeedTimestamp} instead. This
 * timestamp may describe a packet without speed, so it is only the status time
 * when the asset has no speed observation at all.
 */
export function getVehicleDeviceDataTimestamp(vehicleData = {}) {
  const sourceTime = vehicleData?.device_data?.source_time;
  const serverTime = vehicleData?.device_data?.server_time;

  return sourceTime?.v ?? sourceTime ?? serverTime?.v ?? serverTime;
}

/**
 * Observation time of the speed field for a latest-vehicles aggregate item,
 * read from `device_data.velocity.t`.
 *
 * This is the canonical `movement.observedAt` for the latest API. The generic
 * `device_data.source_time` / `server_time` are deliberately NOT used as a
 * fallback: a login, heartbeat or any other non-speed packet must never make an
 * old speed observation look current (#119052). When the speed observation time
 * is missing or unusable, freshness is unknown and the caller degrades to the
 * existing unknown/offline behavior.
 *
 * @param {Object} [vehicleData] - Latest-vehicles aggregate item.
 * @returns {number|null} Epoch milliseconds of the speed observation, or null.
 */
export function getVehicleSpeedTimestamp(vehicleData = {}) {
  const rawTimestamp = vehicleData?.device_data?.velocity?.t;
  if (rawTimestamp === null || rawTimestamp === undefined || rawTimestamp === "") {
    return null;
  }

  const timestamp = Number(rawTimestamp);
  return Number.isFinite(timestamp) ? timestamp : null;
}

const hasTrackingSpeed = (speed) =>
  speed !== null && speed !== undefined && speed !== "" && Number.isFinite(Number(speed));

export function selectLatestDeviceMovement(latestDevice, realtimePacket) {
  const aggregateSpeed = latestDevice?.device_data?.velocity?.v?.speed;
  const aggregate = hasTrackingSpeed(aggregateSpeed)
    ? { speed: Number(aggregateSpeed), observedAt: getVehicleSpeedTimestamp(latestDevice) }
    : null;
  const realtimeSpeed = realtimePacket?.velocity?.speed;
  const realtimeTime = parseSourceTimestamp(realtimePacket?.source_time);
  const realtime = realtimePacket?.packet_type === "device_data" && hasTrackingSpeed(realtimeSpeed)
    ? {
        speed: Number(realtimeSpeed),
        observedAt: Number.isFinite(realtimeTime) ? realtimeTime : null,
      }
    : null;

  if (!realtime) return aggregate;
  if (!aggregate) return realtime;
  return realtime.observedAt !== null &&
    (aggregate.observedAt === null || realtime.observedAt >= aggregate.observedAt)
    ? realtime
    : aggregate;
}

export function resolveTrackingStatus(movement, ignition, deviceDataAt) {
  const hasMovement = hasTrackingSpeed(movement?.speed);
  const packetTime = parseSourceTimestamp(deviceDataAt);
  const observedAt = hasMovement
    ? movement.observedAt ?? null
    : Number.isFinite(packetTime) && packetTime > 0 ? packetTime : null;
  const rawSpeed = hasMovement ? Number(movement.speed) : null;
  return {
    observedAt,
    rawSpeed,
    movementStatus: getVehicleMovementStatus(ignition, rawSpeed, observedAt),
  };
}

export function selectLatestTelemetrySnapshot(...snapshots) {
  return snapshots.reduce((latest, snapshot) => {
    const speed = snapshot?.velocity?.speed;
    const hasValidSpeed =
      speed !== null &&
      speed !== undefined &&
      speed !== "" &&
      Number.isFinite(Number(speed));
    const timestamp = parseSourceTimestamp(snapshot?.source_time);

    if (!hasValidSpeed || !Number.isFinite(timestamp)) return latest;

    const latestTimestamp = parseSourceTimestamp(latest?.source_time);
    return !Number.isFinite(latestTimestamp) || timestamp >= latestTimestamp
      ? snapshot
      : latest;
  }, null);
}

/**
 * Pure, total resolver for the vehicle movement status. For any inputs it
 * returns exactly one of "moving" | "paused" | "parked" | "offline" and never throws.
 *
 * Logic:
 * - "offline" → no datapoint, or latest datapoint is more than 1 hour old
 * - Temporary current release, regardless of ignition:
 *   - "parked" → datapoint age > 5 minutes (regardless of speed)
 *   - "moving" → valid speed > 3 km/h AND datapoint age ≤ 5 minutes
 *   - "paused" → speed ≤ 3 km/h (including 0 or unavailable) AND
 *     datapoint age ≤ 5 minutes
 * - Next release after restoring ignition checks:
 *   - "moving" → ignition On/not available AND speed > 3 km/h
 *   - "paused" → ignition On/not available AND speed ≤ 3 km/h
 *   - "parked" → ignition Off, or no usable speed
 *
 * On the "parked" vs "paused" overlap while ignition is ignored: the spec
 * discriminates the two by ignition (Off → parked, On → paused) and only
 * constrains "parked" by the 5 minute window. With ignition unavailable that
 * window becomes the only remaining discriminator: any speed ≤ 3 km/h
 * (including zero) counts as "paused" while the datapoint is fresh (≤ 5 min),
 * and "parked" once stale (> 5 min). Restore the ignition rules to move the
 * 5 minute window back to being a "parked" precondition only.
 *
 * @param {*} ignition - Raw ignition value (any type accepted by getIgnitionStatus).
 * @param {*} speedMps - Raw speed in metres per second (any type; coerced/clamped).
 * @param {*} observedAt - Speed observation time in milliseconds, i.e.
 *   `movement.observedAt` (`device_data.velocity.t` for the latest aggregate, or
 *   the `source_time` of a speed-bearing packet). A generic packet time must not
 *   be passed here (#119052). Invalid or missing values resolve to "offline".
 *   The status duration label must be derived from this same value.
 * @returns {"moving"|"paused"|"parked"|"offline"} The resolved movement status.
 */
export function getVehicleMovementStatus(ignition, speedMps, observedAt) {
  const sourceTime = observedAt;
  const offlineThreshold = 60 * 60 * 1000; // 1 hour
  const parkedThreshold = 5 * 60 * 1000; // 5 minutes
  const timestamp = parseSourceTimestamp(sourceTime);

  // 1. offline: no data point or beyond 1 hour
  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return "offline";
  }

  // Strictly greater than: a datapoint exactly 1 hour old is still online,
  // matching "no data point beyond 1 hour". This mirrors the exclusive
  // comparisons used for the 3 km/h and 5 minute thresholds below.
  const dataPointAge = Date.now() - timestamp;
  if (dataPointAge > offlineThreshold) {
    return "offline";
  }

  const hasSpeed =
    speedMps !== null &&
    speedMps !== undefined &&
    speedMps !== "" &&
    Number.isFinite(Number(speedMps));

  // Compare against the unrounded km/h value. Rounding to 1 decimal first
  // (as normalizeSpeedKmph does for display) would shift both boundaries:
  // speeds under 0.05 km/h would collapse to 0 and speeds up to 3.05 km/h
  // would stay below the moving threshold.
  const speedKmph = hasSpeed ? Math.max(0, msToKmph(Number(speedMps))) : 0;

  if (IGNORE_IGNITION_FOR_MOVEMENT_STATUS) {
    // stale data (> 5 min) → always parked, regardless of speed
    if (dataPointAge > parkedThreshold) return "parked";
    if (speedKmph > SPEED_THRESHOLD_KMPH) return "moving";
    // speed ≤ 3 km/h with fresh data (≤ 5 min) → paused
    return "paused";
  }

  const ignitionState = getIgnitionStatus(ignition);

  // 2. parked: ignition off OR ignition null/unknown (and last received < 1 hour)
  if (ignitionState === "Off") {
    return "parked";
  }

  // For ignition null/unknown: check speed to decide parked vs paused vs moving
  if (ignitionState === "Not Available") {
    if (speedKmph > SPEED_THRESHOLD_KMPH) {
      return "moving";
    }
    // If no usable speed data or speed ≤ threshold, treat as parked
    const hasSpeed =
      speedMps !== null &&
      speedMps !== undefined &&
      speedMps !== "" &&
      Number.isFinite(Number(speedMps));
    return hasSpeed ? "paused" : "parked";
  }

  // 3 & 4. ignition On: check speed
  // paused: speed ≤ 3 km/h
  // moving: speed > 3 km/h
  return speedKmph > SPEED_THRESHOLD_KMPH ? "moving" : "paused";
}

/**
 * Resolves a vehicle status from one canonical telemetry snapshot. Realtime
 * device-data values take precedence only when their source timestamp is at
 * least as new as the formatted API point. Other packet types must not refresh
 * the location age.
 *
 * @param {Object} point - Formatted API/list/map point.
 * @param {Object} realtimeData - Optional latest WebSocket telemetry.
 * @returns {Object} The merged telemetry point including movementStatus.
 */
export function resolveVehicleStatusSnapshot(point = {}, realtimeData) {
  const pointSourceTime = point?.source_time ?? point?.lastUpdated;
  const realtimeSourceTime = realtimeData?.source_time;
  const pointTimestamp = parseSourceTimestamp(pointSourceTime);
  const realtimeTimestamp = parseSourceTimestamp(realtimeSourceTime);
  const useRealtimeData =
    realtimeData?.packet_type === "device_data" &&
    Number.isFinite(realtimeTimestamp) &&
    (!Number.isFinite(pointTimestamp) || realtimeTimestamp >= pointTimestamp);
  const ignition = useRealtimeData
    ? realtimeData?.ignition ?? point?.ignition
    : point?.ignition;
  const rawSpeed = useRealtimeData
    ? realtimeData?.velocity?.speed ?? point?.rawSpeed
    : point?.rawSpeed;
  const sourceTime = useRealtimeData ? realtimeSourceTime : pointSourceTime;

  return {
    ...point,
    ignition,
    rawSpeed,
    source_time: sourceTime,
    lastUpdated: sourceTime,
    movementStatus: getVehicleMovementStatus(ignition, rawSpeed, sourceTime),
  };
}

export const MOVEMENT_STATUS_PRESENTATION = {
  moving: {
    icon: "status-moving",
    color: "#5EAE62",
    localizationKey: "vehicle_status_moving",
    defaultLabel: "Moving",
  },
  paused: {
    icon: "status-paused",
    color: "#4FC6FD",
    localizationKey: "vehicle_status_paused",
    defaultLabel: "Paused",
  },
  parked: {
    icon: "status-parked",
    color: "#FFAC41",
    localizationKey: "vehicle_status_parked",
    defaultLabel: "Parked",
  },
  offline: {
    icon: "status-offline",
    color: "#9CA3AF",
    localizationKey: "vehicle_status_offline",
    defaultLabel: "Offline",
  },
};

export function getMovementStatusCounts(assets = []) {
  const counts = { moving: 0, paused: 0, parked: 0, offline: 0 };

  assets.forEach((asset) => {
    const status = asset?.movementStatus === "stopped" ? "parked" : asset?.movementStatus;
    counts[counts[status] === undefined ? "offline" : status] += 1;
  });

  return counts;
}

export const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export function getRotation(direction) {
  return direction !== undefined && !isNaN(direction) ? (direction * Math.PI) / 180 : 0;
}

/**
 * Keeps tracking points that can be placed on a map. Direction is optional;
 * marker renderers fall back to a zero-degree rotation when it is unavailable.
 */
export function getRenderableTrackingPoints(points = [], identifierField) {
  if (!Array.isArray(points)) return [];

  return points.filter(
    (point) =>
      point?.lat != null &&
      point?.lng != null &&
      point?.[identifierField] != null
  );
}

/**
 * Generates arrow point features at regular pixel-distance intervals along a track path.
 * Used to render directional arrows on the QIMap (OpenLayers) polyline.
 *
 * @param {Array} trackPoints - Array of {lat, lng} objects representing the track
 * @param {number} intervalMeters - Approximate distance in meters between arrows (default: 500)
 * @param {number} minPoints - Minimum number of track points required to generate arrows (default: 2)
 * @returns {Array} Array of {lat, lng, direction} objects for arrow placement
 */
export function generateDirectionalArrowPoints(trackPoints, intervalMeters = 500, minPoints = 2) {
  if (!trackPoints || trackPoints.length < minPoints) return [];

  // Calculate bearing between two lat/lng points (in degrees 0-360)
  const calcBearing = (p1, p2) => {
    const lat1 = (p1.lat * Math.PI) / 180;
    const lat2 = (p2.lat * Math.PI) / 180;
    const dLng = ((p2.lng - p1.lng) * Math.PI) / 180;
    const y = Math.sin(dLng) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
    const bearing = (Math.atan2(y, x) * 180) / Math.PI;
    return (bearing + 360) % 360;
  };

  // Calculate distance between two lat/lng points using Haversine (in meters)
  const calcDistance = (p1, p2) => {
    const R = 6371000; // Earth radius in meters
    const lat1 = (p1.lat * Math.PI) / 180;
    const lat2 = (p2.lat * Math.PI) / 180;
    const dLat = lat2 - lat1;
    const dLng = ((p2.lng - p1.lng) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const arrows = [];
  let accumulatedDistance = intervalMeters; // Start at interval so first arrow appears after the interval

  for (let i = 1; i < trackPoints.length; i++) {
    const prev = trackPoints[i - 1];
    const curr = trackPoints[i];

    if (!prev || !curr || prev.lat == null || prev.lng == null || curr.lat == null || curr.lng == null) continue;

    const segmentDist = calcDistance(prev, curr);
    accumulatedDistance += segmentDist;

    if (accumulatedDistance >= intervalMeters) {
      const bearing = calcBearing(prev, curr);
      arrows.push({
        lat: curr.lat,
        lng: curr.lng,
        direction: bearing,
      });
      accumulatedDistance = 0;
    }
  }

  return arrows;
}

// Sort array by timestamp and remove duplicates based on timestamp
export function sortAndRemoveDuplicatesByTimestamp(array, newItem) {
  const combined = [...array, newItem];
  // Sort by timestamp (source time) and remove duplicates based on timestamp
  return combined
    .sort((a, b) => a.timestamp - b.timestamp)
    .filter((item, index, arr) => index === 0 || item.timestamp !== arr[index - 1].timestamp);
}

/**
 * Utility functions for role-based access control
 * This module centralizes role checking logic to support multiple admin role types
 */

/**
 * Check if the current user has admin privileges
 * @param {Object} currentUser - The current user object
 * @param {number} selectedAppId - The selected application ID
 * @returns {boolean} - True if user has Admin, Fleet Admin, or Tracking Portal Admin role
 */
export const hasAdminRole = (currentUser, selectedAppId) => {
  const currentAppRoles = currentUser?.client_app_roles;
  let isAdmin = false;

  currentAppRoles?.forEach((clientData) => {
    if (clientData?.client_app_id === selectedAppId) {
      clientData?.roles?.forEach((role) => {
        if (
          role?.name === "Admin" ||
          role?.name === "Fleet Admin" ||
          role?.name === "Tracking Admin"
        ) {
          isAdmin = true;
        }
      });
    }
  });

  return isAdmin;
};

/**
 * Get user ID for filtering, returns empty string if user has admin role
 * @param {Object} currentUser - The current user object
 * @param {number} selectedAppId - The selected application ID
 * @returns {string|number} - User ID if non-admin, empty string if admin
 */
export const getUserIdForFiltering = (currentUser, selectedAppId) => {
  const isAdmin = hasAdminRole(currentUser, selectedAppId);
  return isAdmin ? "" : currentUser?.id;
};

/**
 * Standstill Data Transformation Utilities
 * Functions for transforming standstill data from API format to internal model
 */

/**
 * Generates a unique ID for a standstill entry
 * @param {Object} entry - The standstill entry
 * @param {number} index - The index in the array
 * @returns {string} Unique identifier
 */
function generateStandstillId(entry, index) {
  return `standstill-${entry.start_time}-${index}`;
}

/**
 * Checks if a GPS position is valid
 * @param {Object} gps - GPS object from API
 * @returns {boolean} True if position is valid
 */
function isValidGpsPosition(gps) {
  return (
    gps &&
    gps.position &&
    gps.position.is_valid === true &&
    typeof gps.position.lat === 'number' &&
    typeof gps.position.lng === 'number'
  );
}

/**
 * Transforms address data from API format to internal model
 * @param {Object} gps - GPS object from API
 * @returns {Object|null} Address object or null if unavailable
 */
function transformAddress(gps) {
  if (!gps || !gps.position || !gps.position.address) {
    return null;
  }

  const addr = gps.position.address;

  if (!addr.name && !addr.street && !addr.city && !addr.country) {
    return null;
  }

  return {
    name: addr.name || '',
    street: addr.street || '',
    city: addr.city || '',
    region: addr.region || '',
    country: addr.country || '',
    postalCode: addr.postal_code || '',
  };
}

/**
 * Transforms a single standstill entry from API format to internal model
 * @param {Object} apiEntry - Standstill entry from API response
 * @param {number} index - Index in the array (for ID generation)
 * @returns {Object|null} Transformed standstill entry or null if invalid
 */
export function transformStandstillEntry(apiEntry, index = 0) {
  if (!apiEntry) {
    return null;
  }

  if (
    typeof apiEntry.start_time !== 'number' ||
    typeof apiEntry.end_time !== 'number' ||
    typeof apiEntry.duration !== 'number'
  ) {
    return null;
  }

  if (apiEntry.duration < 0) {
    return null;
  }

  if (!isValidGpsPosition(apiEntry.gps)) {
    return null;
  }

  return {
    id: generateStandstillId(apiEntry, index),
    startTime: apiEntry.start_time,
    endTime: apiEntry.end_time,
    duration: apiEntry.duration,
    position: {
      lat: apiEntry.gps.position.lat,
      lng: apiEntry.gps.position.lng,
      isValid: apiEntry.gps.position.is_valid,
    },
    address: transformAddress(apiEntry.gps),
    gps: apiEntry.gps, // Keep original GPS data for popup
  };
}

/**
 * Transforms an array of standstill entries from API format to internal model
 * @param {Array} apiEntries - Array of standstill entries from API
 * @returns {Array} Array of transformed standstill entries
 */
export function transformStandstillData(apiEntries) {
  if (!Array.isArray(apiEntries)) {
    return [];
  }

  return apiEntries
    .map((entry, index) => transformStandstillEntry(entry, index))
    .filter(entry => entry !== null);
}

/**
 * Standstill Formatter Utilities
 * Pure functions for formatting standstill data for display
 */

/**
 * Formats duration from milliseconds to human-readable string
 * @param {number} durationMs - Duration in milliseconds
 * @returns {string} Formatted duration (e.g., "23 min", "2 hr 15 min")
 */
export function formatDuration(durationMs) {
  if (durationMs < 0) {
    return "< 1 sec";
  }

  const seconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(durationMs / 60000);
  const hours = Math.floor(durationMs / 3600000);

  if (durationMs < 60000) {
    return seconds === 0 ? "< 1 sec" : `${seconds} sec`;
  }

  if (durationMs < 3600000) {
    return `${minutes} min`;
  }

  const remainingMinutes = minutes % 60;
  if (remainingMinutes === 0) {
    return `${hours} hr`;
  }
  return `${hours} hr ${remainingMinutes} min`;
}

/**
 * Formats timestamp to date string
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @param {string} locale - Locale for formatting (default: user's locale)
 * @param {string} timezone - IANA timezone identifier
 * @returns {string} Formatted date (e.g., "2/3/2026")
 */
export function formatDate(timestamp, locale = navigator.language, timezone = undefined) {
  const date = new Date(timestamp);
  const options = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  };

  if (timezone) {
    options.timeZone = timezone;
  }

  return date.toLocaleDateString(locale, options);
}

/**
 * Formats timestamp to time string
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @param {string} locale - Locale for formatting (default: user's locale)
 * @param {string} timezone - IANA timezone identifier
 * @returns {string} Formatted time (e.g., "11:30 PM")
 */
export function formatTime(timestamp, locale = navigator.language, timezone = undefined) {
  const date = new Date(timestamp);
  const options = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  if (timezone) {
    options.timeZone = timezone;
  }

  return date.toLocaleTimeString(locale, options);
}

/**
 * Gets display address from standstill GPS data
 * @param {Object} gps - GPS object from standstill entry
 * @returns {string} Address string or coordinates fallback
 */
export function getDisplayAddress(gps) {
  if (!gps || !gps.position) {
    return "Unknown location";
  }

  const { position } = gps;
  const { address, lat, lng } = position;

  if (address) {
    // Format: [city, state/region]
    const city = address.city || '';
    const region = address.region || '';

    if (city && region) {
      return `${city}, ${region}`;
    }
    if (city) return city;
    if (region) return region;

    // Fallback to street or name if city/region not available
    if (address.street) return address.street;
    if (address.name) return address.name;
  }

  // Fallback to coordinates
  if (lat !== undefined && lng !== undefined) {
    return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
  }

  return "Unknown location";
}

/**
 * Returns an inline SVG HTML string for the standstill bell-z icon
 * Uses the native icons sprite from Tracking assets
 * @param {number} size - Icon size in pixels (default: 18)
 * @returns {string} SVG HTML string
 */
export function getStandstillBellIcon(size = 18) {
  return `<svg width="${size}" height="${size}" style="display:inline-block;vertical-align:middle;flex-shrink:0;"><use href="${spriteNative}#bell-z" style="color:#0767d0;"></use></svg>`;
}

/**
 * Menghitung total durasi dari array standstill items.
 * @param {Array<StandstillItem>} items - Array standstill dalam satu cluster
 * @returns {number} Total durasi dalam milliseconds
 */
export function sumDurations(items) {
  return items.reduce((total, item) => total + (item.duration || 0), 0);
}

/**
 * Menghitung posisi tengah (centroid) dari array standstill items.
 * @param {Array<StandstillItem>} items - Array standstill dalam satu cluster
 * @returns {{lat: number, lng: number}} Posisi centroid
 */
export function clusterCentroid(items) {
  if (items.length === 0) {
    return { lat: 0, lng: 0 };
  }
  const sumLat = items.reduce((sum, item) => sum + item.position.lat, 0);
  const sumLng = items.reduce((sum, item) => sum + item.position.lng, 0);
  return {
    lat: sumLat / items.length,
    lng: sumLng / items.length,
  };
}

/**
 * Helper: get a date key (YYYY-MM-DD) from a timestamp for grouping.
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Date key string
 */
function getDateKey(timestamp) {
  const d = new Date(timestamp);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

/**
 * Menghitung cluster dari array standstill berdasarkan posisi piksel.
 * Hanya standstill dengan tanggal yang sama yang akan dikelompokkan dalam satu cluster.
 * Greedy distance-based clustering per tanggal: iterasi marker satu per satu,
 * tambahkan ke cluster terdekat jika jarak piksel ≤ radius DAN tanggal sama, atau buat cluster baru.
 *
 * @param {Array<StandstillItem>} standstills - Array standstill yang sudah ditransformasi
 * @param {Function} toPixel - Fungsi konversi (lat, lng) => {x, y} piksel pada viewport, atau null jika di luar viewport
 * @param {number} radius - Radius clustering dalam piksel (default: 60)
 * @returns {Array<ClusterGroup>} Array cluster groups
 */
export function clusterStandstills(standstills, toPixel, radius = 60) {
  if (!standstills || standstills.length === 0) {
    return [];
  }

  // Partition standstills by date first
  const byDate = {};
  for (const marker of standstills) {
    const key = getDateKey(marker.startTime);
    if (!byDate[key]) byDate[key] = [];
    byDate[key].push(marker);
  }

  // Cluster within each date group using pixel distance
  const allClusters = []; // { items: [], pixelX, pixelY }

  for (const dateKey of Object.keys(byDate)) {
    const markers = byDate[dateKey];
    const dateClusters = [];

    for (const marker of markers) {
      const pixel = toPixel(marker.position.lat, marker.position.lng);
      if (!pixel) continue;

      let bestClusterIdx = -1;
      let bestDist = Infinity;

      for (let i = 0; i < dateClusters.length; i++) {
        const c = dateClusters[i];
        const dx = pixel.x - c.pixelX;
        const dy = pixel.y - c.pixelY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist <= radius && dist < bestDist) {
          bestDist = dist;
          bestClusterIdx = i;
        }
      }

      if (bestClusterIdx >= 0) {
        const c = dateClusters[bestClusterIdx];
        const n = c.items.length;
        c.pixelX = (c.pixelX * n + pixel.x) / (n + 1);
        c.pixelY = (c.pixelY * n + pixel.y) / (n + 1);
        c.items.push(marker);
      } else {
        dateClusters.push({
          items: [marker],
          pixelX: pixel.x,
          pixelY: pixel.y,
        });
      }
    }

    allClusters.push(...dateClusters);
  }

  // Convert internal clusters to ClusterGroup output format
  return allClusters.map((c, index) => {
    const isSingle = c.items.length === 1;
    return {
      id: isSingle ? c.items[0].id : `cluster-${index}`,
      items: c.items,
      centroid: clusterCentroid(c.items),
      totalDuration: sumDurations(c.items),
      count: c.items.length,
    };
  });
}

/**
 * Membuat DOM element untuk cluster marker.
 * Menampilkan: angka jumlah standstill (kiri) | ikon bell | total durasi (kanan)
 * Style visual konsisten dengan single standstill marker.
 *
 * @param {ClusterGroup} cluster - Cluster group data
 * @param {Function} onClick - Callback saat cluster diklik
 * @returns {HTMLElement} DOM element cluster marker
 */
export function createClusterMarkerElement(cluster, onClick) {
  const duration = formatDuration(cluster.totalDuration);

  const { container } = createMapInfoDialog({
    pill: { prefix: String(cluster.count), icon: "bell-z", text: duration },
    header: {},
    className: "",
  });

  container.setAttribute("data-cluster-marker", "true");

  if (typeof onClick === "function") {
    const pill = container.querySelector(".qi-map-info-dialog_pill");
    if (pill) {
      pill.addEventListener("click", (e) => {
        e.stopPropagation();
        onClick(cluster);
      });
    }
  }

  return container;
}


/**
 * Membuat DOM element untuk dropdown list cluster.
 * Uses QIMapInfoDialog BEM classes for consistent styling.
 * @param {ClusterGroup} cluster - Cluster group data
 * @param {string} vehicleReg - Plat nomor kendaraan
 * @param {Function} onItemClick - Callback saat item diklik (menerima standstill item)
 * @param {Function} onClose - Callback saat dropdown ditutup
 * @returns {HTMLElement} DOM element dropdown
 */
export function createClusterDropdownElement(cluster, vehicleReg, onItemClick, onClose) {
  const container = document.createElement("article");
  container.className = "qi-map-info-dialog_popover";
  container.setAttribute("role", "dialog");

  // ── List View ──
  var listView = document.createElement("nav");
  listView.className = "qi-map-info-dialog_list";

  // Header with close button
  var header = document.createElement("header");
  header.className = "qi-map-info-dialog_list_header";

  var title = document.createElement("h3");
  title.className = "qi-map-info-dialog_list_header_title";
  title.textContent = "Standstills (" + cluster.count + ")";

  var closeBtn = document.createElement("button");
  closeBtn.className = "qi-map-info-dialog_header_close";
  closeBtn.setAttribute("type", "button");
  closeBtn.setAttribute("aria-label", "Close");
  closeBtn.textContent = "\u00D7";
  closeBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    if (typeof onClose === "function") onClose();
  });

  header.appendChild(title);
  header.appendChild(closeBtn);
  listView.appendChild(header);

  // Group items by date
  var groups = {};
  var groupOrder = [];
  for (var i = 0; i < cluster.items.length; i++) {
    var item = cluster.items[i];
    var dateKey = formatDate(item.startTime);
    if (!groups[dateKey]) {
      groups[dateKey] = [];
      groupOrder.push(dateKey);
    }
    groups[dateKey].push(item);
  }

  // Render groups
  for (var g = 0; g < groupOrder.length; g++) {
    var dateLabel = groupOrder[g];
    var items = groups[dateLabel];

    // Date header
    var dateHeader = document.createElement("h4");
    dateHeader.className = "qi-map-info-dialog_list_date-group";
    dateHeader.textContent = dateLabel;
    dateHeader.setAttribute("data-date-header", dateLabel);
    listView.appendChild(dateHeader);

    // Items list
    var itemList = document.createElement("ul");
    itemList.setAttribute("role", "list");
    itemList.style.cssText = "list-style:none;margin:0;padding:0;";

    for (var j = 0; j < items.length; j++) {
      (function (standstillItem) {
        var row = document.createElement("li");
        row.className = "qi-map-info-dialog_list_item";
        row.setAttribute("role", "button");
        row.setAttribute("tabindex", "0");

        var regSpan = document.createElement("span");
        regSpan.className = "qi-map-info-dialog_list_item_reg";
        regSpan.textContent = vehicleReg;

        var timeEl = document.createElement("time");
        timeEl.className = "qi-map-info-dialog_list_item_time";
        timeEl.textContent = formatTime(standstillItem.startTime);

        var durEl = document.createElement("data");
        durEl.className = "qi-map-info-dialog_list_item_duration";
        durEl.setAttribute("value", standstillItem.duration);
        durEl.textContent = formatDuration(standstillItem.duration);

        row.appendChild(regSpan);
        row.appendChild(timeEl);
        row.appendChild(durEl);

        row.addEventListener("click", function (e) {
          e.stopPropagation();
          showDetail(standstillItem);
          if (typeof onItemClick === "function") onItemClick(standstillItem);
        });

        itemList.appendChild(row);
      })(items[j]);
    }

    listView.appendChild(itemList);
  }

  container.appendChild(listView);

  // ── Detail View (hidden by default) ──
  var detailView = document.createElement("div");
  detailView.style.cssText = "display:none;";
  container.appendChild(detailView);

  // Switch to detail view for a given standstill item
  function showDetail(standstillItem) {
    var loc = getDisplayAddress(standstillItem.gps);
    var date = formatDate(standstillItem.startTime);
    var time = formatTime(standstillItem.startTime);
    var dur = formatDuration(standstillItem.duration);

    detailView.innerHTML = "";

    // Detail header with back button
    var detailHeader = document.createElement("header");
    detailHeader.className = "qi-map-info-dialog_header";

    var leftGroup = document.createElement("div");
    leftGroup.className = "qi-map-info-dialog_header_left";

    var backBtn = document.createElement("button");
    backBtn.className = "qi-map-info-dialog_header_back";
    backBtn.setAttribute("type", "button");
    backBtn.setAttribute("aria-label", "Back to list");
    backBtn.textContent = "\u2190";
    backBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      detailView.style.display = "none";
      listView.style.display = "";
    });

    var bellSpan = createSpriteIcon("bell-z", "qi-map-info-dialog_header_icon");

    var titleEl = document.createElement("h3");
    titleEl.className = "qi-map-info-dialog_header_title";
    titleEl.textContent = "Standstill";

    leftGroup.appendChild(backBtn);
    leftGroup.appendChild(bellSpan);
    leftGroup.appendChild(titleEl);

    var regBadge = document.createElement("span");
    regBadge.className = "qi-map-info-dialog_header_badge";
    regBadge.textContent = vehicleReg;

    detailHeader.appendChild(leftGroup);
    detailHeader.appendChild(regBadge);
    detailView.appendChild(detailHeader);

    // Location / address
    var bodySection = document.createElement("section");
    bodySection.className = "qi-map-info-dialog_body";
    var addressEl = document.createElement("address");
    addressEl.textContent = loc;
    bodySection.appendChild(addressEl);
    detailView.appendChild(bodySection);

    // Date, time, duration footer
    var footerEl = document.createElement("footer");
    footerEl.className = "qi-map-info-dialog_footer";

    var dateEl = document.createElement("time");
    dateEl.className = "qi-map-info-dialog_footer_date";
    dateEl.textContent = date;

    var timeDetailEl = document.createElement("time");
    timeDetailEl.className = "qi-map-info-dialog_footer_time";
    timeDetailEl.textContent = time;

    var durDetailEl = document.createElement("data");
    durDetailEl.className = "qi-map-info-dialog_footer_duration";
    durDetailEl.setAttribute("value", standstillItem.duration);
    durDetailEl.textContent = dur;

    footerEl.appendChild(dateEl);
    footerEl.appendChild(timeDetailEl);
    footerEl.appendChild(durDetailEl);
    detailView.appendChild(footerEl);

    // Switch views
    listView.style.display = "none";
    detailView.style.display = "";
  }

  return container;
}



/**
 * Creates a cluster marker dialog (pill + cluster dropdown popover) using QIMapInfoDialog.
 * Replaces inline DOM creation in VehicleTrack.
 *
 * @param {Object} group - Cluster group data
 * @param {string} vehicleReg - Vehicle registration number
 * @returns {{ container: HTMLElement, open: Function, close: Function }}
 */
export function createClusterDialog(group, vehicleReg) {
  const totalDuration = formatDuration(group.totalDuration);

  // Build the cluster dropdown as the popover body
  const onClose = () => { result.close(); };
  const dropdownEl = createClusterDropdownElement(group, vehicleReg, () => {}, onClose);

  // We use createMapInfoDialog for the pill, but replace the popover with the dropdown
  const result = createMapInfoDialog({
    pill: { prefix: String(group.count), icon: "bell-z", text: totalDuration },
    header: null,
    body: null,
    footer: null,
  });

  // Replace the empty popover with the cluster dropdown
  const popover = result.container.querySelector(".qi-map-info-dialog_popover");
  if (popover) {
    popover.parentNode.replaceChild(dropdownEl, popover);
  }

  // Override open/close to toggle the dropdown
  const pillEl = result.container.querySelector(".qi-map-info-dialog_pill");
  const arrows = result.container.querySelectorAll(".qi-map-info-dialog_arrow");
  const pillArrow = arrows.length > 1 ? arrows[1] : null;
  const popoverArrow = arrows.length > 0 ? arrows[0] : null;

  result.open = () => {
    dropdownEl.style.display = "";
    if (popoverArrow) popoverArrow.style.display = "";
    if (pillEl) pillEl.style.display = "none";
    if (pillArrow) pillArrow.style.display = "none";
  };

  result.close = () => {
    dropdownEl.style.display = "none";
    if (popoverArrow) popoverArrow.style.display = "none";
    if (pillEl) pillEl.style.display = "";
    if (pillArrow) pillArrow.style.display = "";
  };

  result.container._closePopover = result.close;

  // Initial state: dropdown hidden
  dropdownEl.style.display = "none";

  return result;
}

/**
 * Renders vehicle plate-number labels as DOM overlays on the QI Map (OpenLayers).
 *
 * Styling lives in `Vehicles/VehicleMap.scss` (`.qi-vehicle-label` and the
 * `.qi-vehicle-label-overlay:hover` rule that raises the OL overlay container).
 *
 * Overlays are cached on the OL map instance (olMap.__vehicleLabelOverlays) keyed
 * by plate_number, and reused/updated across redraws to avoid flicker.
 *
 * @param {Object} mapRef - QI Map ref exposing getMapReference()
 * @param {Array} points - Valid tracking points ({ lat, lng, plate_number, statusIcon, statusColor })
 * @param {Function} onLabelClick - Optional click handler called with the clicked point.
 */
export function renderQiMapLabels(mapRef, points, onLabelClick) {
  if (!mapRef || typeof mapRef.getMapReference !== "function") return;
  const olMap = mapRef.getMapReference();
  if (!olMap || typeof olMap.addOverlay !== "function") return;

  // Cache of active overlays keyed by plate_number
  if (!olMap.__vehicleLabelOverlays) {
    olMap.__vehicleLabelOverlays = new Map();
  }
  const overlays = olMap.__vehicleLabelOverlays;
  const seen = new Set();

  (points || []).forEach((point) => {
    const key = point.plate_number;
    if (key == null) return;
    seen.add(key);

    let entry = overlays.get(key);

    if (!entry) {
      // Build label DOM element (styling via .qi-vehicle-label in SCSS)
      const el = document.createElement("div");
      el.className = "qi-vehicle-label";
      el.setAttribute("role", "button");
      el.setAttribute("tabindex", "0");

      // Status icon (built from the main icons sprite). Color is dynamic per
      // movement status, so it stays inline.
      const iconWrapper = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      iconWrapper.setAttribute("class", "qi-vehicle-label_icon");
      iconWrapper.setAttribute("width", "18");
      iconWrapper.setAttribute("height", "18");
      const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
      use.setAttributeNS("http://www.w3.org/1999/xlink", "href", `${sprite}#${point.statusIcon}`);
      iconWrapper.style.color = point.statusColor || "#4b5563";
      iconWrapper.appendChild(use);
      el.appendChild(iconWrapper);

      const textSpan = document.createElement("span");
      textSpan.className = "qi-vehicle-label_text";
      textSpan.textContent = point.plate_number;
      el.appendChild(textSpan);

      // The OL overlay container (wrapper) gets a dedicated class so a single
      // CSS :hover rule can raise it above sibling overlays (real z-index).
      const overlay = new Overlay({
        element: el,
        positioning: "bottom-center",
        stopEvent: true,
        offset: [0, 0],
        className: "ol-overlay-container ol-selectable qi-vehicle-label-overlay",
      });
      olMap.addOverlay(overlay);

      entry = { overlay, el, iconWrapper, textSpan };
      overlays.set(key, entry);
    } else {
      // Update existing label content if changed
      if (entry.textSpan.textContent !== point.plate_number) {
        entry.textSpan.textContent = point.plate_number;
      }
      const svg = entry.iconWrapper;
      if (svg) {
        const use = svg.querySelector("use");
        if (use) {
          use.setAttributeNS("http://www.w3.org/1999/xlink", "href", `${sprite}#${point.statusIcon}`);
        }
        svg.style.color = point.statusColor || "#4b5563";
      }
    }

    entry.point = point;
    entry.el.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      onLabelClick && onLabelClick(entry.point);
    };
    entry.el.onkeydown = (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        onLabelClick && onLabelClick(entry.point);
      }
    };
    entry.overlay.setPosition(fromLonLat([point.lng, point.lat]));
  });

  // Remove overlays for vehicles no longer present
  overlays.forEach((entry, key) => {
    if (!seen.has(key)) {
      olMap.removeOverlay(entry.overlay);
      overlays.delete(key);
    }
  });
}

/**
 * Removes all vehicle label overlays from the QI Map.
 * @param {Object} mapRef - QI Map ref exposing getMapReference()
 */
export function clearQiMapLabels(mapRef) {
  if (!mapRef || typeof mapRef.getMapReference !== "function") return;
  const olMap = mapRef.getMapReference();
  if (!olMap || !olMap.__vehicleLabelOverlays) return;
  olMap.__vehicleLabelOverlays.forEach((entry) => {
    olMap.removeOverlay(entry.overlay);
  });
  olMap.__vehicleLabelOverlays.clear();
}

/**
 * Renders device labels as DOM overlays on the QI Map (OpenLayers).
 * Similar to renderQiMapLabels but keyed by device ID (imei) and displays
 * movement status icon + device ID text.
 *
 * @param {Object} mapRef - QI Map ref exposing getMapReference()
 * @param {Array} points - Valid tracking points ({ lat, lng, imei, statusIcon, statusColor })
 * @param {Function} onLabelClick - Optional click handler called with the clicked point.
 */
export function renderQiMapDeviceLabels(mapRef, points, onLabelClick) {
  if (!mapRef || typeof mapRef.getMapReference !== "function") return;
  const olMap = mapRef.getMapReference();
  if (!olMap || typeof olMap.addOverlay !== "function") return;

  // Cache of active overlays keyed by imei (device ID)
  if (!olMap.__deviceLabelOverlays) {
    olMap.__deviceLabelOverlays = new Map();
  }
  const overlays = olMap.__deviceLabelOverlays;
  const seen = new Set();

  (points || []).forEach((point) => {
    const key = point.imei;
    if (key == null) return;
    seen.add(key);

    let entry = overlays.get(key);

    if (!entry) {
      // Build label DOM element (reuses .qi-vehicle-label styling from VehicleMap.scss)
      const el = document.createElement("div");
      el.className = "qi-vehicle-label";
      el.setAttribute("role", "button");
      el.setAttribute("tabindex", "0");

      // Status icon (built from the main icons sprite)
      const iconWrapper = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      iconWrapper.setAttribute("class", "qi-vehicle-label_icon");
      iconWrapper.setAttribute("width", "18");
      iconWrapper.setAttribute("height", "18");
      const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
      use.setAttributeNS("http://www.w3.org/1999/xlink", "href", `${sprite}#${point.statusIcon}`);
      iconWrapper.style.color = point.statusColor || "#4b5563";
      iconWrapper.appendChild(use);
      el.appendChild(iconWrapper);

      const textSpan = document.createElement("span");
      textSpan.className = "qi-vehicle-label_text";
      textSpan.textContent = point.imei;
      el.appendChild(textSpan);

      // The OL overlay container gets a dedicated class for hover z-index behavior
      const overlay = new Overlay({
        element: el,
        positioning: "bottom-center",
        stopEvent: true,
        offset: [0, 0],
        className: "ol-overlay-container ol-selectable qi-vehicle-label-overlay",
      });
      olMap.addOverlay(overlay);

      entry = { overlay, el, iconWrapper, textSpan };
      overlays.set(key, entry);
    } else {
      // Update existing label content if changed
      if (entry.textSpan.textContent !== String(point.imei)) {
        entry.textSpan.textContent = point.imei;
      }
      const svg = entry.iconWrapper;
      if (svg) {
        const use = svg.querySelector("use");
        if (use) {
          use.setAttributeNS("http://www.w3.org/1999/xlink", "href", `${sprite}#${point.statusIcon}`);
        }
        svg.style.color = point.statusColor || "#4b5563";
      }
    }

    entry.point = point;
    entry.el.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      onLabelClick && onLabelClick(entry.point);
    };
    entry.el.onkeydown = (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        onLabelClick && onLabelClick(entry.point);
      }
    };
    entry.overlay.setPosition(fromLonLat([point.lng, point.lat]));
  });

  // Remove overlays for devices no longer present
  overlays.forEach((entry, key) => {
    if (!seen.has(key)) {
      olMap.removeOverlay(entry.overlay);
      overlays.delete(key);
    }
  });
}

/**
 * Removes all device label overlays from the QI Map.
 * @param {Object} mapRef - QI Map ref exposing getMapReference()
 */
export function clearQiMapDeviceLabels(mapRef) {
  if (!mapRef || typeof mapRef.getMapReference !== "function") return;
  const olMap = mapRef.getMapReference();
  if (!olMap || !olMap.__deviceLabelOverlays) return;
  olMap.__deviceLabelOverlays.forEach((entry) => {
    olMap.removeOverlay(entry.overlay);
  });
  olMap.__deviceLabelOverlays.clear();
}
